var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('column-chart',{attrs:{"data":_vm.datoGrafica1,"suffix":"%","download":true,"colors":[['#106b21',  '#fce903', '#ce0018']]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }